<template>
  <wrap ref="wrap" :title="title">
    <div class="datePicker">
      <el-date-picker
        v-model="datePicker"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        size="small"
      >
      </el-date-picker>
      <span @click="search" class="item m10 search t_b-c">查 询</span>
    </div>

    <CTable style="min-height: 200px;" :head="headList" :body="onData(d21.records)">
      <!--
        自定义模版
        slot=head字段名
        slot-scope=数据索引
      -->
      <template slot="time" slot-scope="scope">
        <span class="number">{{ scope.data.time }}</span>
      </template>

      <template slot="numbers" slot-scope="scope">
        <ul slot="recodeNumber" class="lh_num_record">
          <li v-for="(item, index) in scope.data.numbers" :key="'re' + index" class="item lh_item">
            <span v-if="category==4 && index==6" style="font-weight: bold;font-size: 18px;">+</span>
            <span class="numberlhc" :class="filterNumberColor(item,index)">{{ item }}</span>
          </li>
        </ul>
      </template>
      <!--<template slot="numbers" slot-scope="scope" v-else>
        <span class="numbers"
              :class="[type===3?'number2':name,(type===3?'numbernc':name )+ i,name+'cate'+category]"
              v-for="(i, index) in scope.data.numbers"
              :key="'icon' + index"></span>
      </template>-->

      <template slot="cha" slot-scope="scope">
        <div v-if="category==4">
          <span class="cha"
                v-for="(i, index) in scope.data.cha"
                :key="'cha' + index"
                :class="[i=='大'||i=='双'||i=='尾大'||i=='总大'||i=='总双'||i>=175 ? 'red':'blue']"> {{ i }}  </span>
        </div>
        <div v-else class="chapion">
          <span class="cha"
                v-for="(i, index) in scope.data.cha"
                :key="'cha' + index" :class="[i=='大'||i=='双'||i=='尾大'||i=='总大'||i=='总双' ? 'red':'blue']">{{ i }}</span>
        </div>
      </template>

      <template slot="specialNumber" slot-scope="scope">
        <div>
          <span class="cha"
                v-for="(i, index) in scope.data.specialNumber"
                :style="{'color': (i=='绿波' ? 'green':'')}"
                :key="'cha' + index"
                :class="[i=='大'||i=='双'||i=='尾大'||i=='合大'||i=='合双'||i=='家禽'||i=='红波'? 'red':'blue']">{{ i }} </span>
        </div>
      </template>

      <template slot="lh" slot-scope="scope">
        <div class="chapion">
          <span class="cha"
                v-for="(i, index) in scope.data.lh"
                :key="'cha' + index" :class="[i=='龙' ? 'red' : i=='虎' ? 'blue' : ' ']">{{ i }}</span>
        </div>
      </template>

      <template slot="even_odd" slot-scope="scope">
        <div class="chapion">
          <span class="cha" :class="[scope.data.even_odd=='双' ? 'red': 'blue']">{{ scope.data.even_odd }}</span>
        </div>
      </template>
    </CTable>
    <el-pagination
      small
      layout="prev, pager, next"
      :page-size="20"
      :total="d21.total"
      @size-change="onPaginationChange"
      @prev-click="onPaginationChange"
      @next-click="onPaginationChange"
      @current-change="onPaginationChange"
    >
    </el-pagination>
  </wrap>
</template>

<script>
// qc15复用qc14
import myDatepicker from 'vue-datepicker-local';
import CTable from './table';
import Wrap from "./wrap";
import CSelect from "../c_select";
import mixin from './mixin';
import { filterNumber } from "../../utils/objectFactory";
import { mapActions, mapState } from 'vuex';
import { DatePicker, Pagination } from 'element-ui';
import objectPath from 'object-path';

export default {
  name: "QC21",
  mixins: [mixin],
  components: {Wrap, CTable, myDatepicker, CSelect, elPagination: Pagination, elDatePicker: DatePicker},
  data() {
    return {
      type: 0,
      date_end: '',
      params: {},
      date_start: '',
      lottery_type: '',
      category: 0,
      datePicker: '', // 时间区间
      offset: 0, //
      limit: 20,
      headList:[],
    };
  },
  mounted() {
    const show = this.show;
    this.show = () => {
      const info = this.options.find(item => item.value == this.data.lottery_type);
      this.type = info ? info.value : this.options[0].value;
      this.category = info ? info.category : this.options[0].category;
      this.search();
      return show.call(this, ...arguments);
    };
  },
  watch: {
    type() {
      const info1 = this.options.find(item => item.value == this.type);
      this.category = info1 ? info1.category : this.options[0].category;
      this.showhead();
      this.search();
    },
    lottery_type(val, oldVal){//普通的watch监听
        if(oldVal!=val){
          this.showhead();
        }
    },
  },
  computed: {
    ...mapState({
      d21: state => state.table.d21,
      options: state => state.home.headTabs.map(item => ({
        label: item.title,
        value: item.lottery_type,
        category: item.category
      }))
    }),

    date() {
      const n = str => (str < 10 ? '0' : '') + str;
      const d = this.date_start ? new Date(this.date_start) : new Date();
      return [
        d.getFullYear(),
        n(d.getMonth() + 1),
        n(d.getDate())
      ].join('-');
    },
    name() {
      //if (
      //  opt &&
      // opt.label.indexOf('飞艇') >= 0 ||
      //  opt.label.indexOf('赛车') >= 0
      //) return 'number_draw2';
      if (this.category == 3)
        return 'number_draw2';
      return 'number3';
    },
   /* head() {
      if (this.category == 4) {
        return [
          {label: '期数', value: 'time'},
          {label: '开奖日期', value: 'date'},
          {label: '开奖号码', value: 'numbers'},
          {label: '特码', value: 'specialNumber'},
          {label: '生肖', value: 'sx'},
          {label: '尾数', value: 'ws'},
          {label: '总数', value: 'cha'},
        ];
      } else {
        return this.data.head || [
          {label: '期数', value: 'time'},
          {label: '开奖日期', value: 'date'},
          {label: '开奖号码', value: 'numbers'},
          {label: '总和', value: 'cha'},
          {label: '龙 虎', value: 'lh'},
        ];
      }
    },*/
  },
  methods: {
    ...mapActions('table', {
      load_d21_data: 'load_d21_data'
    }),
    showhead(){
      if (this.category_id == 4) {
        this.headList = [
          {label: '期数', value: 'time'},
          {label: '开奖日期', value: 'date'},
          {label: '开奖号码', value: 'numbers'},
          {label: '特码', value: 'specialNumber'},
          {label: '生肖', value: 'sx'},
          {label: '尾数', value: 'ws'},
          {label: '总数', value: 'cha'},
        ];
      }else{
        this.headList = [
          {label: '期数', value: 'time'},
          {label: '开奖日期', value: 'date'},
          {label: '开奖号码', value: 'numbers'},
          {label: '单双', value: 'even_odd'},
        ];
      }
    },
    search(params = {}) {
      const start_date = objectPath.get(this.datePicker, '0') || '';
      const end_date = objectPath.get(this.datePicker, '1') || '';
      const newParams = {
        lottery_type: this.lottery_type,
        start_date,
        end_date,
        offset: this.offset,
        limit: this.limit,
        ...params
      }
      this.load_d21_data(newParams);
    },
    onPaginationChange(value) {
      const offset = value > 1 ? (value - 1) * 20 : 0;
      this.search({offset});
    },
    onData(data = []) {
      const newData = data ? data : [];
      return newData.map(item => {
        item.time = item.period;
        item.date = item.draw_time;
        item.numbers = item.draw_results;
        if (this.category_id == 4) {
          item.cha = [
            item.sum.sum,
            item.sum.da_xiao,
            item.sum.dan_shuang,
            item.sum.wei_shu_da_xiao
          ];
          item.specialNumber = [
            item.special.daXiao,
            item.special.danShuang,
            item.special.weiShu,
            item.special.heShuDaXiao,
            item.special.heShuDanShuang,
            item.special.jiaYe,
            item.special.ballColor,
          ];
        }else if(this.category_id == 5){
          item.even_odd = item.even_odd;
        }
        item.lh = item.longhu;
        return item;
      });
    },
    disabledDate(time) {
      if (!this.date_start) return;
      return new Date(this.date_start).getTime() >= time.getTime();
    },
    // 过滤当前number的背景图片颜色
    filterNumberColor(checkNumber,index) {
      if(this.category_id==5){
        if(index==0){
          return 'ball_yellow';
        }else{
          return 'number-'+checkNumber;
        }
      }
      const isFilterNumber = filterNumber(checkNumber);
      if (isFilterNumber) {
        return isFilterNumber;
      }
      if (checkNumber && isNaN(Number(checkNumber))) {
        if (checkNumber.indexOf('红') > -1) return 'banbo-red';
        if (checkNumber.indexOf('绿') > -1) return 'banbo-green';
        if (checkNumber.indexOf('蓝') > -1) return 'banbo-blue';
        return 'banbo-yellow';
      }
      return '';
    }
  }
}
</script>

<style lang="stylus" scoped>
.lh_num_record {
  display: flex;

  .lh_item {
    display: flex;
    align-items: center;
    margin-left: 0;
    margin-right: 2px;
  }

  .numberlhc {
    width: 30px;
    height: 25px;
    display: flex;
    line-height: 25px;
    align-items: center;
    justify-content: center;
    background-size: contain;
  }

  .number-blue {
    color:#0b0c0c;
    font-weight: bold;
    background: url('../../assets/back_blue.png') no-repeat center center;
  }

  .number-green {
    color:#0b0c0c;
    font-weight: bold;
    background: url('../../assets/back_green.png') no-repeat center center;
  }

  .number-red {
    color:#0b0c0c;
    font-weight: bold;
    background: url('../../assets/back_red.png') no-repeat center center;
  }
}

.number {
  display block
  /*width 80px*/
}

.number3cate1, .number3cate2 {
  width: 27px;
  height: 27px;
}

.numbers {
  margin 0 2px
  /*zoom: 0.7*/
}

.chapion {
  height 100%
  display flex
  justify-content center

  span {
    flex 1
    width 40px
    display flex
    align-items center
    justify-content center
  }

  > span + span {
    border-left 1px solid #e0e0e0
  }
}

.tc-b_h {
  &.review {
    color: #000000;
  }
}

.datePicker {
  height: 30px;
  font-size: 14px;
  color: #000000;
  padding-bottom 3px;

  .select {
    min-width 140px
    white-space nowrap
    width auto
    height 32px
    border-radius 2px
    margin-right 10px
    background-color transparent
    border 1px solid #e0e0e0

    p {
      white-space nowrap
    }
  }

  .m10 {
    margin: 0 10px;
  }

  .search {
    display inline-block;
    height: 100%;
    color: #ffffff;
    vertical-align: top;
    line-height: 28px;
    width: 50px;
    text-align center;
    border-radius: 5px;
    cursor: pointer;
  }
}

.ft-number{
    width: 30px;
    height: 30px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    background-size: contain;
    font-size: 13px;
    font-weight: bold;
    margin: 0 auto;
}
.ball_yellow{
    font-size: 14px;
    font-weight: bold;
    color:#363636;
    background: url('../../assets/ball_yellow.png') no-repeat center center;
  }
.number-1 {
    font-size: 14px;
    font-weight: bold;
    color:#363636;
    background: url('../../assets/1.fw.png') no-repeat center center;
  }

  .number-2 {
    font-size: 14px;
    font-weight: bold;
    color:#363636;
    background: url('../../assets/2.fw.png') no-repeat center center;
  }

  .number-3 {
    font-size: 14px;
    font-weight: bold;
    color:#363636;
    background: url('../../assets/3.fw.png') no-repeat center center;
  }

  .number-4 {
    font-size: 14px;
    font-weight: bold;
    color:#363636;
    background: url('../../assets/4.fw.png') no-repeat center center;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/QC21.vue